module.exports = __webpack_public_path__ + "img/tf.9a169b0c.svg";